<template>
  <section class="section">
    <div class="glass-container animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Participantes</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Usuarios que han participado y calificado en los eventos</p>
          </div>
        </div>
      </div>

      <!-- Filtros -->
      <div class="columns mb-4">
        <div class="column is-4">
          <b-field label="Filtrar por Evento" label-position="on-border" class="glass-field">
            <b-select v-model="idEvento" @input="obtenerParticipantes" expanded class="is-rounded">
              <optgroup label="Selecciona un evento">
                <option :value="null">Todos los participantes</option>
                <option v-for="e in eventos" :key="e.id" :value="e.id">
                  {{ e.nombre }} {{ e.activo == 1 ? '(Activo)' : '' }}
                </option>
              </optgroup>
            </b-select>
          </b-field>
        </div>
      </div>

      <div class="table-container glass-table">
        <b-table
          :data="participantes"
          :hoverable="true"
          :loading="cargando"
          :paginated="true"
          :per-page="perPage"
          :current-page.sync="currentPage"
          pagination-rounded
          mobile-cards
        >
          <b-table-column field="nombre" label="Nombre" v-slot="props">
            <div class="is-flex is-align-items-center">
              <b-icon icon="account-circle-outline" class="mr-2 has-text-primary" size="is-small"></b-icon>
              <span class="has-text-weight-bold">{{ props.row.nombre }}</span>
            </div>
          </b-table-column>
          
          <b-table-column field="telefono" label="Teléfono" v-slot="props">
            <b-tag type="is-info is-light" class="is-rounded glass-tag-info">
              {{ props.row.telefono }}
            </b-tag>
          </b-table-column>

          <b-table-column field="correo" label="Correo" v-slot="props">
            <span class="is-size-7 opacity-7">{{ props.row.correo }}</span>
          </b-table-column>

          <template #empty>
            <div class="has-text-centered py-6">
              <b-icon icon="account-off-outline" size="is-large" class="has-text-grey-light"></b-icon>
              <p class="has-text-grey mt-2">No se encontraron participantes.</p>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </section>
</template>

<script>
import HttpService from '../../Servicios/HttpService';

export default {
  name: 'ParticipantesComponent',
  data() {
    return {
      participantes: [],
      eventos: [],
      idEvento: null,
      cargando: false,
      currentPage: 1,
      perPage: 15
    };
  },
  mounted() {
    this.cargarDatosIniciales();
    document.title = 'Metropolitan - Participantes';
  },
  methods: {
    cargarDatosIniciales() {
      this.cargando = true;
      HttpService.registrar('eventos.php', { accion: 'actual' })
        .then(eventoActual => {
          if (eventoActual) this.idEvento = eventoActual.id;
          
          return Promise.all([
            HttpService.registrar('eventos.php', { accion: 'obtener' }),
            this.obtenerParticipantes()
          ]);
        })
        .then(([eventos]) => {
          this.eventos = eventos || [];
          this.cargando = false;
        });
    },
    obtenerParticipantes() {
      this.cargando = true;
      return HttpService.registrar('participantes.php', { accion: 'obtener', id_evento: this.idEvento })
        .then(res => {
          this.participantes = res || [];
          this.cargando = false;
        });
    }
  }
};
</script>

<style scoped>
.glass-container {
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  min-height: 80vh;
}

.glass-field /deep/ .label { 
  color: #94a3b8 !important; 
  font-weight: 500;
}

.glass-field /deep/ .select select {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-radius: 12px !important;
}

.glass-field /deep/ .select select option {
  background: #1e293b;
  color: white;
}

.glass-table /deep/ .table {
  background: transparent !important;
  color: white !important;
}

.glass-table /deep/ .table thead th {
  background: rgba(255, 255, 255, 0.03) !important;
  color: #3b82f6 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  padding: 15px;
}

.glass-table /deep/ .table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.9);
  padding: 15px;
}

.glass-tag-info {
  background: rgba(59, 130, 246, 0.1) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  color: #60a5fa !important;
}

.opacity-7 { opacity: 0.7; }

@media screen and (max-width: 768px) {
  .section { padding: 15px 10px; }
  .glass-container { padding: 20px; }
}
</style>
